import Model from 'src/app/common/model';

export default class WaterReadingsModel extends Model {

  id: string;
  pH: number;
  salinity: number;
  alkalinity: number;
  turbidity: number;
  tan: number;
  temperature: number;
  uam: number;
  sg: number;
  do2: number;
  conductivity: number;
  tds: number;
  nitrite: number;
  orp: number;
  magnesium: number;
  calcium: number;
  biofloc: number;
  carbonates: number;
  bicarbonates: number;
  hardness: number;
  ammonia: number;
  plankton: number;
  bod: number;
  co2: number;
  phosphorus: number;
  h2sGas: number;
  iron: number;
  potassium: number;
  da: number;
  sodium: number;
  tank_id: number;
  farm_site_id: string;
  person_id: string;
  water_type_id: number;
  soil_type_id: number;
  device_id: string;
  comment: string;
  cust_added_params: any;
  tank_number: string;
  pond_culture_id: string;
  created_by: string;
  updated_by: string;
  device_number: string;
  recommendation: any;
  isPreparatory: number;
  test_type: number;
  time_interval: number;
  source_batch_number: string;
  isBH: boolean;
  location_tracker_id: string;
  createdAt: Date;
  updatedAt: Date;
  readingSets?: Array<any>;
  time: string;
  to: string;
  fromDate: string;
  toDate: string;
  batch_entry_id?: number;
  business_id: string;
  section_id: number;
  business_name: string;
  batch_type: string
  hybridUpdate?: boolean;
  readings?: Array<WaterReadingsModel>;
  deleted: number;
  device_uuid: string;

  constructor() {
    super();
  }
}
